'use client';

import { useTranslations } from 'next-intl';
import BaseSidebarLayout from '@/components/common/BaseSidebarLayout';
import { useParams } from 'next/navigation';

type Props = {
    children: React.ReactNode;
};

export default function TermsConditionsLayout({ children }: Props) {
    const params = useParams();
    const locale = params.locale as string;
    const t = useTranslations('CommonTermsAndConditions');

    const menuItems = [
        {
            id: 'terms-conditions',
            label: t('items.terms'),
            href: `/${locale}/terms-conditions`,
        },
        {
            id: 'privacy-policy',
            label: t('items.privacy'),
            href: `/${locale}/terms-conditions/privacy-policy`,
        },
        {
            id: 'aml-notice',
            label: t('items.amlNotice'),
            href: `/${locale}/terms-conditions/aml-notice`,
        },
    ];

    return <BaseSidebarLayout menuItems={menuItems} title={t('title')}>{children}</BaseSidebarLayout>;
}
